<template>
    <div>
        <nav class="navbar-dark bg-gradient" id="top-nav">
            <div class="container">
                <div class="golotus-navigation">
                    <div
                        v-if="!hideNavigation"
                        id="menu-toggle"
                        class="mr-4 d-flex justify-content-center align-items-center d-md-none"
                    >
                        <i
                            class="fa fa-bars fa-lg text-white cursor-pointer p-3"
                            @click="$bus.$emit('show-sidemenu')"
                        ></i>
                    </div>

                    <a class="bar-logo mr-2 py-2 py-sm-4 d-flex align-items-center" href="/account">
                        <img src="../../images/logo.png" alt="goLOTUS" style="max-width: 30vw;" />
                    </a>

                    <div class="d-none d-sm-flex ml-auto" v-if="!hideNavigation">
                        <div class="btn-group px-3 ml-auto">
                            <button
                                class="btn btn-link text-white dropdown-toggle"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                {{ goalsPatientName }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-right two-columns">
                                <a
                                    class="dropdown-item"
                                    v-for="client in userOrgClients"
                                    :href="`/patients/${client.id}/goals`"
                                >
                                    <img
                                        class="img-fluid mr-2 profile-image"
                                        :src="client.profile_photo_url"
                                        data-private
                                    />{{ client.name }}</a
                                >
                                <span
                                    v-if="!userOrgClients.length"
                                    class="dropdown-item font-italic"
                                >
                                    No patient found.
                                </span>
                                <span
                                    v-if="canAddClient"
                                    class="dropdown-item d-flex align-items-center"
                                    @click="goLink(`/connections`)"
                                >
                                    <span>
                                        <i class="fa fa-2x fa-plus text-muted pr-2 mr-1"></i>
                                    </span>
                                    <a class="text-black" href="/connections">Add Client</a>
                                </span>
                            </div>
                        </div>

                        <template v-if="canUseTrackers">
                            <div class="btn-group px-3">
                                <button
                                    @click="goDataTracker()"
                                    :class="currentPage === 'Data Tracker' ? 'active' : ''"
                                    class="btn btn-link text-white"
                                    type="button"
                                    id="data-tracker-button"
                                >
                                    Data Tracker
                                </button>
                            </div>
                        </template>
                    </div>

                    <div class="btn-group px-3 ml-auto">
                        <button
                            class="btn btn-link text-white dropdown-toggle text-left active"
                            type="button"
                            id="accountMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <span>{{
                                user && user.hasOwnProperty("first_name") ? user.first_name : ""
                            }}</span
                            ><br />
                            <span class="small font-weight-light">{{
                                currentOrganization ? currentOrganization.name : ""
                            }}</span>
                        </button>

                        <div class="dropdown-menu dropdown-menu-right">
                            <template v-if="organizations.length > 1">
                                <h6 class="dropdown-header">Organizations</h6>
                                <a
                                    class="dropdown-item text-primary font-weight-bold"
                                    href="#"
                                    :id="`org-${currentOrganization.id}`"
                                    >{{ currentOrganization.name }}</a
                                >
                                <a
                                    class="dropdown-item"
                                    :id="`org-${organization.id}`"
                                    v-for="organization in organizations.filter(
                                        org => org.id !== currentOrganization.id
                                    )"
                                    @click="setOrganization(organization.id)"
                                    href="#"
                                >
                                    {{ organization.name }}
                                </a>
                                <div class="dropdown-divider"></div>
                            </template>
                            <a
                                class="dropdown-item"
                                v-for="a in accountMenu"
                                @click="goLink(a.url)"
                                :href="a.url"
                            >
                                {{ a.title }}
                            </a>

                            <div class="dropdown-divider"></div>

                            <a
                                v-if="subscription.is_upgradable"
                                class="dropdown-item"
                                @click="goLink('upgrade')"
                            >
                                <a href="/upgrade"
                                    >Billing
                                    <span class="badge badge-pill badge-primary"
                                        >Upgrade Now!</span
                                    ></a
                                >
                            </a>
                            <a class="dropdown-item" @click="signout"><a>Sign out</a></a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import { permissions } from "../plugins/permissions";

export default {
    name: "GoLotusHeader",
    props: [
        "currentPage",
        "user",
        "organizations",
        "userOrgClients",
        "appUrl",
        "patientId",
        "hideNavigation",
        "currentOrganization",
        "subscription",
    ],
    mixins: [permissions],
    data() {
        return {
            accountMenu: [
                { title: "Help Center", class: "footer", url: "/help" },
                // { title: "My Promotions", url: "/referrals" },
                { title: "Account Settings", url: "/account-settings" },
            ],
        };
    },

    created() {
        this.$bus.$emit("set-app-url", this.appUrl);
    },

    computed: {
        goalsPatientName() {
            if (this.patientId && this.userOrgClients.length) {
                let user = this.userOrgClients.find(c => c.id === this.patientId);
                if (user) {
                    return `${user.first_name} Goals`;
                }
            }
            return "Client Goals";
        },
    },

    methods: {
        goLink(url) {
            window.location.href = url;
        },
        goDataTracker() {
            this.goLink("/data-tracker");
            this.$emit("page", "goals");
        },
        signout() {
            axios
                .post("/logout")
                .then(() => {
                    window.location.href = this.appUrl;
                })
                .catch(e => {
                    console.error(e);
                    window.location.href = this.appUrl;
                });
        },
        setOrganization(id) {
            this.$emit("set-organization", id);
        },
    },
};
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

.bg-gradient {
    background: rgb(57, 31, 63);
    background: linear-gradient(90deg, rgba(57, 31, 63, 1) 0%, rgba(65, 88, 121, 1) 100%);
}

.golotus-navigation {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    color: white;
    > div {
        cursor: pointer;
    }
    > .bar-logo > img {
        //max-width: 2rem;
    }
    > .current-page {
        cursor: pointer;
        font-size: 0.8rem;
    }
    > .nav-icon {
        padding: 0.5rem 0.5rem;
    }
}

.nohover:hover {
    background-color: inherit !important;
}

.btn-link {
    border-radius: 0;
    padding: 0;
}
.active,
.btn-link:hover,
.btn-link:focus {
    box-shadow: inset 0 -5px 0 0 white;
    text-decoration: none;
}

.btn-link .dropdown-toggle:hover {
    box-shadow: inset 0 -5px 0 0 white;
    text-decoration: none;
}

.dropdown-toggle:hover {
    box-shadow: none !important;
    text-decoration: none;
}

.profile-image {
    min-width: 1.5rem;
    max-width: 1.5rem;
    min-height: 1.5rem;
    max-height: 1.5rem;
}

@media screen and (min-width: 576px) {
    .golotus-navigation {
        > .current-page {
            cursor: pointer;
            font-size: 1rem;
        }
    }
}
</style>
